import { SectionTitle } from "@components";
import { ServiceHistory } from "./ServiceHistory";

import { ServicesHistoryType } from "@type/HRM/services";

interface ServiceHistoryPropsType {
  servicesHistoryInfo: ServicesHistoryType[];
  changeServiceHistoryInfo: (data: ServicesHistoryType) => void;
  removeServiceHistoryInfo: (servicesHistoryID: number) => void;
  getServicesRequestOngoing: boolean;
  updateServicesHistoryRequestOngoing: boolean;
  deleteServicesHistoryRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

const ServicesHistory = ({
  servicesHistoryInfo,
  changeServiceHistoryInfo,
  removeServiceHistoryInfo,
  getServicesRequestOngoing,
  updateServicesHistoryRequestOngoing,
  deleteServicesHistoryRequestOngoing,
  isProfileDisabled
}: ServiceHistoryPropsType) => {
  return (
    <div className="d-flex flex-column gap-8">
      <SectionTitle
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.HEADING"
        size="lg"
        noBorder
      />

      {servicesHistoryInfo?.map((serviceHistory) => (
        <ServiceHistory
          key={serviceHistory.id}
          serviceHistoryInfo={serviceHistory}
          changeServiceHistoryInfo={changeServiceHistoryInfo}
          removeServiceHistoryInfo={removeServiceHistoryInfo}
          getServicesRequestOngoing={getServicesRequestOngoing}
          updateServicesHistoryRequestOngoing={
            updateServicesHistoryRequestOngoing
          }
          deleteServicesHistoryRequestOngoing={
            deleteServicesHistoryRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
      ))}
    </div>
  );
};

export default ServicesHistory;
